export default __webpack_public_path__ + "static/symptomsRecord-82aa342beac4c766806f01818f47a93f.jpg";